import React from 'react';

interface PanelReturnAlertProps {
  title?: string;
}

const PanelReturnAlert: React.FC<PanelReturnAlertProps> = ({ title = "WELCOME BACK" }) => {
  return (
    <div className="panel-return-alert">
      <div className="return-content">
        <span className="return-text">{title}</span>
      </div>
    </div>
  );
};

export default PanelReturnAlert;
